import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const VendorContext = createContext();

export function useVendor() {
  return useContext(VendorContext);
}

export function VendorProvider({ children }) {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('vendorToken'));

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      checkVendorAuth();
    } else {
      setLoading(false);
    }
  }, [token]);

  const checkVendorAuth = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/vendor/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVendor(response.data);
    } catch (error) {
      console.error('Vendor auth check failed:', error);
      localStorage.removeItem('vendorToken');
      setToken(null);
    } finally {
      setLoading(false);
    }
  };

  const loginWithOTP = (accessToken, vendorData) => {
    localStorage.setItem('vendorToken', accessToken);
    setToken(accessToken);
    setVendor(vendorData);
  };

  const logout = () => {
    localStorage.removeItem('vendorToken');
    setToken(null);
    setVendor(null);
    delete axios.defaults.headers.common['Authorization'];
    toast.success('Logged out successfully');
  };

  const updateVendor = (updatedData) => {
    setVendor(prev => ({ ...prev, ...updatedData }));
  };

  const value = {
    vendor,
    token,
    loading,
    loginWithOTP,
    logout,
    updateVendor,
    isAuthenticated: !!vendor,
    isApproved: vendor?.status === 'approved',
    isPending: vendor?.status === 'pending'
  };

  return (
    <VendorContext.Provider value={value}>
      {children}
    </VendorContext.Provider>
  );
}
